var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutboundcall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "outbound_call",
    "data-name": "outbound call",
    xmlns: "http://www.w3.org/2000/svg",
    width: 469.334,
    height: 469.334,
    viewBox: "0 0 469.334 469.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2262",
    "data-name": "Group 2262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19685",
    "data-name": "Path 19685",
    d: "M234.667,0C105.271,0,0,114.844,0,256V373.333A10.667,10.667,0,0,0,10.667,384h32v42.667a42.709,42.709,0,0,0,42.667,42.667h32A10.661,10.661,0,0,0,128,458.667v-192A10.661,10.661,0,0,0,117.334,256h-32a42.709,42.709,0,0,0-42.667,42.667V256c0-117.635,86.135-213.333,192-213.333s192,95.7,192,213.333v42.667A42.709,42.709,0,0,0,384,256H352a10.661,10.661,0,0,0-10.667,10.667v192A10.661,10.661,0,0,0,352,469.334h32a42.709,42.709,0,0,0,42.667-42.667V384h32a10.667,10.667,0,0,0,10.667-10.667V256C469.333,114.844,364.063,0,234.667,0Z",
    fill: "#7dbaab"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutboundcall);
export default __webpack_public_path__ + "static/media/outbound call.9c247bd3bdbee8d19a17e95b2c9ac979.svg";
export { ForwardRef as ReactComponent };